<template>
  <ul class="flex flex-col mb-0 gap-6">
    <li v-for="{ name, layers, someVisible, allVisible } in layerGroups" :key="`${name}`" class="dropdown-item-container">
      <template v-if="layerGroups.length === 1">
        <DeckDeprecatedLayers
          :layers="(layers as Layer[])"
          :disabled="disabled"
          @set-layer-visible="$emit('set-layer-visible', $event)"
          @layer-hover="$emit('layer-hover', $event)"
        />
      </template>
      <DeckDeprecatedCollapsibleGroup v-else :title="name">
        <template #title>
          <VCheckbox
            class="inline-block w-4 h-4 mr-2 text-center align-middle leading-8"
            :model-value="someVisible"
            :partial="!allVisible"
            :disabled="disabled"
            @update:model-value="setGroupVisibility(layers as Layer[], !someVisible)"
          />
        </template>
        <DeckDeprecatedLayers
          :layers="(layers as Layer[])"
          :disabled="disabled"
          @set-layer-visible="$emit('set-layer-visible', $event)"
          @layer-hover="$emit('layer-hover', $event)"
        />
      </DeckDeprecatedCollapsibleGroup>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { Layer } from '~/composables/useThreeDLayerGroups'
import type { LayerGroup } from '~/composables/useThreeDViewer'

defineProps({
  layerGroups: {
    type: Array as PropType<LayerGroup[]>,
    required: true,
  },
  disabled: {
    type: [Boolean, String] as PropType<boolean | 'true' | 'false'>,
    default: false,
  },
})

const emit = defineEmits(['set-layer-visible', 'layer-hover'])

const setGroupVisibility = (layerList: Layer[], visible: boolean): void => {
  emit(
    'set-layer-visible',
    layerList.map(layer => ({ nodeId: layer.nodeId, visible }))
  )
}
</script>

<style lang="stylus" scoped>
:deep(.controls-container .control-button)
  padding calc(0.75rem - 1px) // Modify padding to have button size match slide buttons
  border-width 0
</style>
